module.exports = __webpack_public_path__ + "img/shield-lock.cf22eee3.svg";